export default {
  MORNING_START: '06:00',
  MORNING_END: '11:00',
  AFTERNOON_START: '11:00',
  AFTERNOON_END: '17:00',
  EVENING_START: '17:00',
  EVENING_END: '24:00',
}
